<template>
    <div>
        <preloading-analytic-kpis v-if="loading"/>
        <div v-else-if="error" class="w-100 text-center py-5">
            <p class="text-muted mb-0">{{ error }}</p>
        </div>
        <div v-else class="w-100 h-screen bg-white">
            <iframe
                title="Documentación del recomendador"
                :srcdoc="html"
                frameborder="0"
                allowfullscreen
                class="w-100 h-full"
                style="min-height: 800px;">
            </iframe>
        </div>
    </div>
</template>
<script>
import { mapActions } from "vuex";

import preloadingAnalyticKpis from '../../../components/loadings/placeholderAnalyticKpis.vue';
export default {
    name: "documentation-kpis",
    components: {
        preloadingAnalyticKpis
    },
    data() {
        return {
            loading: true,
            html: '',
            error: null
        };
    },
    created(){
        this.getDocumentation()
    },
    methods: {
        ...mapActions([
            'get'
        ]),
        getDocumentation(){
            this.loading = true;
            this.error = null;
            this.get({
                url: '/api/pricemachines/documentation/'
            }).then((response) => {
                this.html = response.html || '';
                this.loading = false;
            }).catch(() => {
                this.error = 'No hay documentación cargada en la plataforma.';
                this.loading = false;
            });
        }
    }
};
</script>
